<template lang="pug">
.container
  h1.main_title Dashboard
    .w3-right
      v-select.time_range_list(
        v-bind:value.sync="selectedTimeRange"
        v-bind:options="timeRangeOptions"
      )
  .w3-panel.w3-padding-32(v-if="dataLoading")
    .loader
    h4.w3-center.w3-animate-fading Loading...
  div(v-else)
    .w3-padding
      .w3-row
        h2 Total
        .w3-col.l12(v-for="data in outputData.total")
          notify-block(v-bind:data.sync="data" v-bind:is-major="true")
    .w3-row
      .w3-col(v-for="brand in brandList" v-bind:class="`l${Math.round(12 / brandList.length)}`")
        h2.w3-margin.text-capitalize {{ brand }}
        .w3-col.l12(v-for="data in outputData[brand]")
          notify-block(v-bind:data.sync="data")
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import { getService } from '../../index.js'
  import { option, select } from 'vue-strap'
  import notifyBlock from '../common/NotifyBlock'

  export default {
    components: {
      notifyBlock,
      'v-option': option,
      'v-select': select
    },
    data () {
      return {
        /* hard data */
        brandList: ['gomax', 'intrising', 'lantech', 'evoip'],
        /* time range */
        timeRangeOptions: [
          {
            value: 'all',
            label: 'All'
          },
          {
            value: 'month',
            label: 'This Month'
          },
          {
            value: 'week',
            label: 'This Week'
          },
          {
            value: 'day',
            label: 'Today'
          }
        ],
        selectedTimeRange: 'month',
        /* data status */
        fbServiceLoaded: false,
        /* output data */
        outputData: {},
        demOutputData: {
          total: [
            {
              type: {
                name: 'mail',
                texTransform: 'text-capitalize'
              },
              amount: 10,
              limit: 3000,
              description: '10/3000',
              percentage: (_.round(_.toFinite(1300 / 3000), 2) * 100),
              progressbarIsNeeded: true
            },
            {
              type: {
                name: 'sms',
                texTransform: 'text-uppercase'
              },
              amount: 10,
              limit: 3000,
              description: '10/3000',
              percentage: (_.round(_.toFinite(2330 / 3000), 2) * 100),
              progressbarIsNeeded: true
            },
            {
              type: {
                name: 'price',
                texTransform: 'text-capitalize'
              },
              description: '$3000',
              progressbarIsNeeded: false
            }
          ]
        }
      }
    },
    vuex: {
      getters: {
        user: state => state.user,
        selectedCurrency: state => state.selectedCurrency
      }
    },
    firebase () {
      return {
        fbService: {
          source: getService(),
          readyCallback: () => {
            this.fbServiceLoaded = true
          }
        }
      }
    },
    computed: {
      dataLoading () {
        if (this.fbServiceLoaded) {
          const {gomax = [], intrising = [], lantech = [], evoip = []} = this.dataGroupByFrom
          this.outputData = {
            total: this.dataTransformer('total', this.dataNormalized),
            gomax: this.dataTransformer('gomax', gomax),
            intrising: this.dataTransformer('intrising', intrising),
            lantech: this.dataTransformer('lantech', lantech),
            evoip: this.dataTransformer('evoip', evoip)
          }
          return false
        } else {
          return true
        }
      },
      timeRangeFiltering () {
        const dataset = [...this.fbService]
        const rangeType = this.selectedTimeRange
        const today = new Date().toISOString()
        return rangeType === 'all'
          ? dataset
          : _.filter(dataset, data => moment(data.time).isSame(today, rangeType))
      },
      dataNormalized () {
        const dataset = [...this.timeRangeFiltering]
        /* assign a new property for numberis price */
        _.forEach(dataset, (data, index) => {
          if (data.type === 'sms') {
            dataset[index] = {
              ...data,
              price: _.toFinite(data['message-price'] || data['price'])
            }
          }
        })
        return dataset
      },
      dataGroupByFrom () {
        return _.groupBy([...this.dataNormalized], 'from')
      }
    },
    ready () {
      if (this.$route.name === 'demo') {
        /* demo add on */
        let p = 0
        setInterval(() => {
          if (!this.dataLoading) {
            const { total, gomax, lantech, intrising } = this.outputData
            const list = [total, gomax, lantech, intrising]
            const sample = _.sample(list)
            _.forEach(sample, (data, index) => {
              switch (data.type.name) {
                case 'mail':
                  if (data.percentage < 90) {
                    data.amount += 100
                    data.description = this.formatNumber(`${data.amount}/${data.limit}`)
                    data.percentage = (_.round(_.toFinite(data.amount / data.limit * 100), 2))
                  }
                  break
                case 'sms':
                  if (data.percentage < 90) {
                    data.amount += 10
                    data.description = this.formatNumber(`${data.amount}/${data.limit}`)
                    data.percentage = (_.round(_.toFinite(data.amount / data.limit * 100), 2))
                    p = data.amount * 0.0442
                  }
                  break
                case 'price':
                  p = _.round(p, 5)
                  data.description = `€ ${p}`
                  break
              }
            })
          }
        }, 1000)
      }
    },
    methods: {
      dataTransformer (name, sourceData) {
        let totalPrice = 0
        const dataGroupByType = _.groupBy([...sourceData], 'type')
        const { symbol_native: symbolNative, rates } = this.selectedCurrency

        /* due to the hard coded of LIMIT is 3000 & 100, needed to multiply the amount of FROM to implement TOTAL */
        const amountOFrom = name === 'total' ? 3 : 1

        const formedData = _.sortBy(
          _.transform(dataGroupByType, (result, data, key) => {
            /* temp record = flash */
            const flash = { type: {} }
            /* specific */
            switch (key) {
              case 'mail':
                flash.type.texTransform = 'text-capitalize'
                flash.limit = 3000 * amountOFrom
                break
              case 'sms':
                flash.type.texTransform = 'text-uppercase'
                flash.limit = 100 * amountOFrom
                totalPrice = _.sumBy(data, 'price')
                break
            }

            /* common */
            flash.type.name = key
            flash.progressbarIsNeeded = true
            flash.amount = _.size(data)
            flash.description = this.formatNumber(`${flash.amount}/${flash.limit}`)
            flash.percentage = (_.round(_.toFinite(flash.amount / flash.limit * 100), 2))
            result.push(flash)
          }, [])
        , 'type.name')

        /* view null situation */
        // console.group(name)
        // console.table({
        //   mail: {
        //     name,
        //     notExist: _.findIndex(formedData, { type: { name: 'mail' } }) === -1
        //   },
        //   sms: {
        //     name,
        //     notExist: _.findIndex(formedData, { type: { name: 'sms' } }) === -1
        //   }
        // })
        // console.groupEnd()

        /* handle null situation */
        if (_.findIndex(formedData, { type: { name: 'mail' } }) === -1) {
          /* no mail data from db, so add null case */
          formedData.push({
            type: {
              name: 'mail',
              texTransform: 'text-capitalize'
            },
            amount: 0,
            limit: 3000 * amountOFrom,
            description: `0/${this.formatNumber(3000 * amountOFrom)}`,
            percentage: 0,
            progressbarIsNeeded: true
          })
        }
        if (_.findIndex(formedData, { type: { name: 'sms' } }) === -1) {
          /* no sms data from db, so add null case */
          formedData.push({
            type: {
              name: 'sms',
              texTransform: 'text-uppercase'
            },
            amount: 0,
            limit: 100 * amountOFrom,
            description: `0/${this.formatNumber(100 * amountOFrom)}`,
            percentage: 0,
            progressbarIsNeeded: true
          })
        }

        /* add price data */
        formedData.push({
          type: {
            name: 'price',
            texTransform: 'text-capitalize'
          },
          description: `${symbolNative} ${_.round(totalPrice * rates, 4)}`,
          progressbarIsNeeded: false
        })

        return formedData
      },
      formatNumber (num) {
        return num.toLocaleString('en')
      }
    }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// Index.vue?36a23452